import { useEffect } from "react";
import { useUserInfo } from "../user";
import { getAnalyticsProvider } from "./analytics";
/**
 * Hook to automatically track user properties (user_id, role) in Google Analytics.
 * Handles both authenticated and guest users.
 *
 * @param isAnalyticsInitialized - Boolean flag indicating if analytics is ready to be used. Defaults to true.
 */
export const useAnalyticsUserTracking = ({ isAnalyticsInitialized = true, } = {}) => {
    const { onlyUserId, role, isAuthLoaded } = useUserInfo();
    useEffect(() => {
        if (!isAnalyticsInitialized || !isAuthLoaded) {
            return;
        }
        const analytics = getAnalyticsProvider();
        if (!analytics) {
            return;
        }
        const userProperties = {};
        if (onlyUserId) {
            userProperties["user_id"] = onlyUserId;
        }
        else {
            userProperties["user_id"] = "";
        }
        const userRole = onlyUserId ? role || "" : "guest";
        userProperties["role"] = userRole;
        analytics.setUserProperties(userProperties);
    }, [onlyUserId, role, isAuthLoaded, isAnalyticsInitialized]);
};
